<template>
    <div>
        <span class="my-search-token"
            v-for="token in tokens"
            :key="token.id"
            role="group"
            :aria-label="`${token.label}: ${token.value}`">{{token.label}}<span v-if="token.label && token.value">:</span> {{ token.value }}

        <button type="button"
            tabindex="0"
            class="close"
            @click="closeToken(token)"
            :aria-label="`Filter '${token.label}: ${token.value}' entfernen`">
            ×
        </button>
        </span>
    </div>
</template>

<script>
    import V from 'voUtils/V.js';
    import DateEx from 'voUtils/DateEx.js';

    export default {
    	voVueComponent: 'search-filter-tokens',
    	props: {
    		searchData: Object,
    		searchFields: Object
    	},
    	data: function() {
    		return {
    			tokens: []
    		};
    	},
    	methods: {
    		deleteCookie: function(name) {
    			document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    		},
    		closeToken: function(token) {
    			const suffix = VOFFICE.token.substr(VOFFICE.token.length - 12);
    			const cookieName = 'searchData_' + suffix;
    			for (let i = 0; i < this.tokens.length; i++) {
    				if (this.tokens[i] === token) {
    					let k = this.tokens[i].id;
    					this.searchData[k] = '';
    					V.log("deleting token", k);

    					if (k === 'from') {
    						this.searchData.till = undefined;
    						this.searchData.nights_max = undefined;
    						this.searchData.nights_min = undefined;
    						this.deleteCookie(cookieName);
    					} else if (k === 'till') {
    						this.searchData.from = undefined;
    						this.searchData.nights_max = undefined;
    						this.searchData.nights_min = undefined;
    						this.deleteCookie(cookieName);
    					} else if (k === 'pets') {
    						this.searchData.petsCount = undefined;
    					} else if (k === 'adults') {
    						this.searchData.adults = 1;
    					} else if (k === 'favorites') {
    						this.searchData[k] = ''
    						this.$parent.favorites = false;
    					}
    					this.tokens.splice(i);

    					this.$nextTick(function() {
    						this.$emit('updated');
    					});
    					break;

    				}
    			}
    		},
    		update: function(nv) {
    			nv = nv || this.searchData;
    			this.tokens = [];
    			var field, value, v;

    			for (let k in nv) {
    				v = nv[k];

    				field = this.searchFields[k];

    				if (field && v && v !== '0' && v !== 'false' && k !== 'region') { //!_.isBlank(v)
    					value = null;

    					if (k === 'from' || k === 'till') {
    						value = DateEx.formatDate(v);
    					} else if (v !== true && v !== 'true' && k !== 'ids') {
    						//show value
    						if (field.options) {
    							value = field.options[v + ''];
    						} else {
    							value = v;
    						}
    					}
    					this.tokens.push({
    						id: k,
    						label: field.label,
    						value: value
    					});
    				} else if (field && v && v !== '0' && v !== 'false' && k === 'region') {
    					//console.log('Field::', field, 'value::', v);
    					value = field.options[v];
    					this.tokens.push({
    						id: k,
    						value: value
    					});
    				}
    			}
    		}
    	}
    };
</script>

<style scoped>
</style>